import { Form, Message, Label } from "semantic-ui-react"
import TextEditor from "../../components/TextEditor"
import { StorePrioritarioType } from "../../pages/FormPrioritario/types"
import "./style.less"
import { useStore } from "../../stores/useStoreProfile"

export interface PropsItemPrioritarioType {
  store: StorePrioritarioType;
  modoEdicao?: boolean;
  editarDescricao?: boolean;
  loading?: boolean;
  checkError?: (e: string) => string;
  checkSucess?: () => string;
  setStore?: (e: any) => void;
  departamento?: any[];
  filtroDepartamento?: number[];
}

const FormItemPrioritario = ({
  store,
  modoEdicao,
  editarDescricao,
  loading,
  checkError = undefined,
  checkSucess = undefined,
  setStore = undefined,
  departamento = undefined,
  filtroDepartamento = [],
}: PropsItemPrioritarioType) => {
  const { dominios } = useStore()
  const { corGrafico } = dominios

  const fixNullValue = (value: number | string | undefined) => {
    if (value === null || value === undefined) {
      return ''
    } else if (value === '') {
      return null
    } else {
      return value
    }
  }

  return (
    <Form
      className="form-item-prioritario"
      error={checkError && Boolean(checkError("detail"))}
      success={checkSucess && Boolean(checkSucess())}
    >
      <Message
        icon="times circle outline"
        error
        header={checkError && checkError("detail")}
      />
      <Message
        icon="check circle outline"
        success
        header={checkSucess && checkSucess()}
      />
      {modoEdicao && (
        <Form.Input
          name="form-titulo"
          required
          label="Título"
          value={store.titulo}
          onChange={(e) => {
            setStore && setStore({ titulo: e.target.value })
          }}
          error={checkError && checkError("titulo")}
          disabled={(store.id || 0) < 0}
        />
      )}

      <Form.Field
        name="form-descricao"
        control={TextEditor}
        label="Descrição"
        value={store.descricao}
        onChange={(e: string) => {
          setStore && setStore({ descricao: e })
        }}
        disabled={(!modoEdicao && !editarDescricao) || ((store.id || 0) < 0)}
      />
      <Form.Group>
        <Form.Select
          required
          name="form-nivel-monitoramento"
          label="Nível Monitoramento"
          error={checkError && checkError("departamento")}
          value={store.departamento || undefined}
          options={
            departamento
              ?.filter((e) => filtroDepartamento.includes(e.id))
              .map((e) => ({ key: e.id, value: e.id, text: e.sigla })) || [
              {
                key: store.departamento,
                value: store.departamento,
                text: store.sigla_departamento,
              },
            ]
          }
          width={5}
          onChange={(e, d) => {
            setStore && setStore({ departamento: d.value, areas_relatoras: [] })
          }}
          disabled={!modoEdicao || (store.id || 0) < 0}
        />
        <Form.Select
          name="form-situacao"
          required
          label="Situação"
          value={1}
          options={[{ key: 1, value: 1, text: store.dsc_situacao }]}
          width={5}
          disabled
        />
        <Form.Input
          name="form-periodicidade"
          label="Periodicidade"
          title="Período, em dias, em que se espera que novos relatórios sejam produzidos"
          value={fixNullValue(store.periodicidade)}
          onKeyDown={(event: KeyboardEvent) =>
            event.key === "." || event.key === "-"
              ? event.preventDefault()
              : null
          }
          error={checkError && checkError("periodicidade")}
          onChange={(e, d) => {
            const isInt = Number.isInteger(+d.value)
            if (isInt) return setStore && setStore({ periodicidade: fixNullValue(d.value) })
          }}
          width={2}
          type="number"
          min={0}
          disabled={!modoEdicao || (store.id || 0) < 0}
        />
        <Form.Input
          name="form-ordem"
          label="Ordem de apresentação"
          title="A ordenação se dá em ordem crescente, com o número sempre valendo como último"
          value={fixNullValue(store.ordem)}
          error={checkError && checkError("ordem")}
          onChange={(e, d) => setStore && setStore({ ordem: fixNullValue(d.value) })}
          width={2}
          type="number"
          min={0}
          disabled={!modoEdicao || (store.id || 0) < 0}
        />
        <Form.Select
          className='select-color-picker'
          name="form-cor"
          label="Cor"
          value={store.corgrafico}
          options={
            corGrafico.map(e =>
              ({
                key: e.id,
                value: e.id,
                text: <label className='color-option' style={{backgroundColor: e.cor_fundo}}><span/>{e.nome_cor}</label>
              })
            )
          }
          onChange={(e, d) => setStore && setStore({ corgrafico: d.value })}
          disabled={!modoEdicao || (store.id || 0) < 0}
          width={2}
          clearable
        />

      </Form.Group>

      <Form.Field label="Áreas Relatoras" title="Áreas que poderão visualizar este card e produzir relatos." error={Boolean(checkError && checkError("areas_relatoras"))} />
      <Form.Group inline>
        {(departamento
          ? departamento.filter(e => e.departamento_pai && e.departamento_pai === store.departamento)
          : store.areas_relatoras
        )?.map((e) => (
          <Form.Field name="form-areas-relatoras" key={e.id}>
            <Form.Checkbox
              name={e.sigla}
              label={e.sigla}
              checked={store.areas_relatoras?.map((ar) => ar.id).includes(e.id)}
              onChange={() => {
                let ar = store.areas_relatoras || []
                ar = ar.map((ar) => ar.id).includes(e.id)
                  ? ar.filter((ar) => ar.id !== e.id)
                  : [...ar, e]
                setStore && setStore({ areas_relatoras: ar })
              }}
              disabled={!modoEdicao || (store.id || 0) < 0}
              error={Boolean(checkError && checkError("areas_relatoras"))}
            />
          </Form.Field>
        ))}
      </Form.Group>
      {checkError && checkError("areas_relatoras") && <Form.Field>
        <Label basic pointing prompt>
          {checkError && checkError("areas_relatoras")}
        </Label>
      </Form.Field>}
    </Form>
  )
}

export default FormItemPrioritario